import type {
  InstructionsInfoTabKey,
} from '@app-types/instructions';
import type { DisclosureNewsApiLabel } from '@app-types/instructionsApi';

/** Tab shown first on load. */
export const DEFAULT_INFO_TAB_KEY: InstructionsInfoTabKey = 'all';

/**
 * The UI tab key is deliberately separate from the backend label. In
 * particular, `performanceDividend` must be sent as `dividend`.
 */
export const DISCLOSURE_API_LABEL_BY_TAB: Record<
  InstructionsInfoTabKey,
  DisclosureNewsApiLabel
> = {
  all: 'all',
  earnings: 'earnings',
  performanceDividend: 'dividend',
  other: 'other',
};
